import { __decorate } from "tslib";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PageHeadingComponent } from "./components/page-heading/page-heading.component";
import { HighlightPipe } from "./pipes/highlight/highlight.pipe";
import { HighlightWithColumnPipe } from "./pipes/highlight/highlight-with-column.pipe";
import { MatDialogModule } from "@angular/material/dialog";
import { AlertComponent } from "./components/alert/alert.component";
import { CommonModule, DatePipe, TitleCasePipe } from "@angular/common";
import { PwaInstallBottomSheetComponent } from "./components/pwa-install-bottom-sheet/pwa-install-bottom-sheet.component";
import { PrimaryButtonComponent } from "./components/primary-button/primary-button.component";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { SecondaryButtonComponent } from "./components/secondary-button/secondary-button.component";
import { InputComponent } from "./components/input/input.component";
import { MatInputModule } from "@angular/material/input";
import { SaShortDatePipe } from "./pipes/sa-short-date/sa-short-date.pipe";
import { NgPipesModule, UcFirstPipe } from "ngx-pipes";
import { ContentMenuComponent } from "./components/content-menu/content-menu.component";
import { RouterModule } from "@angular/router";
import { QuillModule } from "ngx-quill";
import { AppViewShortDatePipe } from "./pipes/app-view-short-date/app-view-short-date.pipe";
import { MatDividerModule } from "@angular/material/divider";
import { SaLongDatePipe } from "./pipes/sa-long-date/sa-long-date.pipe";
import { UtcDatePipe } from "./pipes/utc-date/utc-date.pipe";
import { SubscriberComponent } from "./components/subscriber/subscriber.component";
import { RecipientFilterComponent } from "./components/recipient-components/shared/recipient-filter/recipient-filter.component";
import { RecipientSelectComponent } from "./components/recipient-components/recipient-select/recipient-select.component";
import { ZaesriAngularCalciteModule } from "../../../../zaesri-angular-calcite/src/lib/zaesri-angular-calcite.module";
import { MatTooltipModule } from "@angular/material/tooltip";
import { AddRecipientModalComponent } from "./components/recipient-components/shared/modal-components/add-recipient-modal/add-recipient-modal.component";
import { AflaCommonModule } from "../../../../afla-common/src/lib/afla-common.module";
import { RecipientListComponent } from "./components/recipient-components/recipient-list/recipient-list.component";
import { EditRecipientModalComponent } from "./components/recipient-components/shared/modal-components/edit-recipient-modal/edit-recipient-modal.component";
import { HelpModalComponent } from "./components/help-modal/help-modal.component";
import { RefreshComponent } from "../create-application/shared/refresh/refresh.component";
import { DragDropDirective } from "./directives/drag-drop.directive";
import { ConfirmDeleteModalComponent } from "./components/recipient-components/shared/modal-components/confirm-delete-modal/confirm-delete-modal.component";
import { TreeModule } from "@ali-hm/angular-tree-component";
import { DocumentTreeViewComponent } from "./components/document-tree-view/document-tree-view.component";
import { PopUpComponent } from "./components/pop-up/pop-up.component";
import { ViewApplicationStepperComponent } from "./components/view-application-stepper/view-application-stepper.component";
import { ViewApplicationHostDirective } from "../view-application/shared/view-application-host.directive";
import { SafeHtmlPipe } from "./pipes/safeHtml/safe-html.pipe";
export let SharedModule = class SharedModule {
};
SharedModule = __decorate([
    NgModule({
        declarations: [
            HighlightPipe,
            HighlightWithColumnPipe,
            SubscriberComponent,
            AlertComponent,
            PageHeadingComponent,
            PwaInstallBottomSheetComponent,
            PrimaryButtonComponent,
            SecondaryButtonComponent,
            InputComponent,
            SaShortDatePipe,
            SaLongDatePipe,
            AppViewShortDatePipe,
            ContentMenuComponent,
            RecipientFilterComponent,
            RecipientSelectComponent,
            AddRecipientModalComponent,
            RecipientListComponent,
            EditRecipientModalComponent,
            HelpModalComponent,
            RefreshComponent,
            DragDropDirective,
            ConfirmDeleteModalComponent,
            DocumentTreeViewComponent,
            PopUpComponent,
            ViewApplicationStepperComponent,
            ViewApplicationHostDirective,
            SafeHtmlPipe,
        ],
        imports: [
            CommonModule,
            MatSelectModule,
            MatIconModule,
            MatButtonModule,
            FormsModule,
            MatDialogModule,
            MatTableModule,
            MatPaginatorModule,
            MatInputModule,
            ReactiveFormsModule,
            NgPipesModule,
            RouterModule,
            QuillModule.forRoot(),
            MatDividerModule,
            ZaesriAngularCalciteModule,
            MatTooltipModule,
            AflaCommonModule,
            TreeModule,
        ],
        exports: [
            HighlightPipe,
            AlertComponent,
            HighlightWithColumnPipe,
            PageHeadingComponent,
            PrimaryButtonComponent,
            SecondaryButtonComponent,
            InputComponent,
            ContentMenuComponent,
            RecipientSelectComponent,
            RecipientListComponent,
            RefreshComponent,
            DragDropDirective,
            DocumentTreeViewComponent,
            PopUpComponent,
            ViewApplicationHostDirective,
            SafeHtmlPipe,
        ],
        providers: [
            SaShortDatePipe,
            AppViewShortDatePipe,
            UcFirstPipe,
            SaLongDatePipe,
            UtcDatePipe,
            DatePipe,
            TitleCasePipe,
            SafeHtmlPipe,
        ]
    })
], SharedModule);
